export default __webpack_public_path__ + "static/media/ico-rds-score-moderate.b890586d.svg";